class InqueryPopup extends HTMLElement {
  constructor() {
    super();

    this.inqueryButton = this.parentElement.querySelector('.buy-buttons .inquery-btn');
    this.popup = this.querySelector('.popup_container');
    this.mask = this.querySelector('.mask-overlay');
    this.closeBtn = this.querySelector('.popup_close_btn');
  }

  showPopup(e){
    if (e.target.closest('button').classList.contains('inquery-btn')) {
      e.preventDefault();
      this.popup.classList.remove('hidden');
      this.closeBtn.addEventListener('click', function() {
        this.closest('.inquery-popup').classList.add('hidden');
      });
      this.mask.addEventListener('click', function() {
        this.closest('.inquery-popup').classList.add('hidden');
      });

      const pdpPopupOptionsWrapper = this.popup.querySelector('.popup-options');
      const allPdpConfigs = document.querySelector('.product-info').querySelectorAll('product-config');

      allPdpConfigs.forEach( function (pdpConfig, index) {
        const legend = pdpConfig.querySelector('legend').textContent;
        const title = pdpConfig.querySelector('.product_advanced_features_item_title_variant').textContent;
        const productID = pdpConfig.querySelector('button.active').getAttribute('data-variant') ? pdpConfig.querySelector('button.active').getAttribute('data-variant') : pdpConfig.querySelector('button.active').getAttribute('data-product');

        const advancedVariantTitleWrapper = document.createElement('div');
        const advancedVariantContent = `${legend} <span class="title">${title}</span>`;
        advancedVariantTitleWrapper.classList.add('text-subdued', 'popup-options-item', `index-${index}`);
        advancedVariantTitleWrapper.innerHTML = advancedVariantContent;

        const advancedVariantInput = document.createElement('input');
        advancedVariantInput.setAttribute('type', 'text');
        advancedVariantInput.setAttribute('name', `advanced_product_${index + 1}`);
        advancedVariantInput.classList.add('advanced_popup_variant_id', `variant_id_index-${index}`, 'hidden');
        advancedVariantInput.value = productID ? title : '';

        if(!pdpPopupOptionsWrapper.querySelector(`.index-${index}`)){
          pdpPopupOptionsWrapper.appendChild(advancedVariantTitleWrapper);
        } else {
          pdpPopupOptionsWrapper.querySelector(`.index-${index}`).innerHTML = advancedVariantContent;
        }

        if(!pdpPopupOptionsWrapper.querySelector(`.variant_id_index-${index}`)){
          pdpPopupOptionsWrapper.appendChild(advancedVariantInput);
        } else {
          pdpPopupOptionsWrapper.querySelector(`.variant_id_index-${index}`).value = productID ? title : '';
        }
      });
    }
  }

  connectedCallback() {
    this.inqueryButton?.addEventListener('click', this.showPopup.bind(this));
  }
}

if(!window.customElements.get('inquery-popup')){
  customElements.define('inquery-popup', InqueryPopup);
}
